
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_ppedz_32",
  "input": "awsui_input_2rhyz_ppedz_36",
  "input-readonly": "awsui_input-readonly_2rhyz_ppedz_89",
  "input-invalid": "awsui_input-invalid_2rhyz_ppedz_122",
  "input-warning": "awsui_input-warning_2rhyz_ppedz_125",
  "input-type-search": "awsui_input-type-search_2rhyz_ppedz_128",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_ppedz_138",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_ppedz_141",
  "input-container": "awsui_input-container_2rhyz_ppedz_145",
  "input-field": "awsui_input-field_2rhyz_ppedz_150",
  "input-field-has-inline-content": "awsui_input-field-has-inline-content_2rhyz_ppedz_173",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_ppedz_176",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_ppedz_191",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_ppedz_199",
  "input-field-warning": "awsui_input-field-warning_2rhyz_ppedz_213",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_ppedz_227",
  "grouped": "awsui_grouped_2rhyz_ppedz_233",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_ppedz_240",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_ppedz_244",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_ppedz_250",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_ppedz_254",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_ppedz_258",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_ppedz_264",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_ppedz_268",
  "grouped-with-error": "awsui_grouped-with-error_2rhyz_ppedz_272",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_ppedz_300",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_ppedz_300",
  "grouped-with-warning": "awsui_grouped-with-warning_2rhyz_ppedz_306",
  "grouped-vertical": "awsui_grouped-vertical_2rhyz_ppedz_254",
  "grouped-horizontal": "awsui_grouped-horizontal_2rhyz_ppedz_240",
  "input-prefix": "awsui_input-prefix_2rhyz_ppedz_367",
  "input-suffix": "awsui_input-suffix_2rhyz_ppedz_368",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_ppedz_382",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_ppedz_391",
  "input-inline-content": "awsui_input-inline-content_2rhyz_ppedz_400",
  "input-icon-start": "awsui_input-icon-start_2rhyz_ppedz_432",
  "input-icon-start-disabled": "awsui_input-icon-start-disabled_2rhyz_ppedz_439",
  "input-icon-end": "awsui_input-icon-end_2rhyz_ppedz_443",
  "input-button-right": "awsui_input-button-right_2rhyz_ppedz_449",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_ppedz_453",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_ppedz_456",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_ppedz_460",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_ppedz_463",
  "inline-label": "awsui_inline-label_2rhyz_ppedz_453",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_ppedz_488"
};
  